import axios from "axios";
import TimeService from "../services/TimeService";
import { DeviceReadinessInfo, IADPState, Manifest, StressTest, ValidationErrorTypes } from "../types";
import { environment, sleep } from "../util";
import { useCheckForUpdatesService } from "./useCheckForUpdatesService";
import { IADPActions } from "../state/Actions";
import { Dispatch } from "react";
import { AppConfigExtended, actions } from "../state";
import { DeviceMetricsService } from "../services/DeviceMetricsService";
import { RunStressTest } from "../services/StressTestService";
import { StressSummary } from "../../Types";
import { AppStateProvider } from "../state/Provider";
import { useDeviceStatusService } from "./useDeviceStatusService";
import { indexDBStorage } from "../storage/indexDBStorage";
import RequestService from "../util/request";
import {ValidationResponse, ValidationResponseCheck, ValidationSummary} from '@npd-ng/adp-types';
const logPrefix = "[ADPClient][DeviceValdation]";
type checkStatus = {
  actionOnFailure: ValidationErrorTypes,
  isClassroomStressTestPassed?: boolean,
  isCheckPassed: boolean
}

export function useDeviceValidationService(dispatch: Dispatch<IADPActions>,appState: IADPState) {
  const {FetchReleaseManifest} = useCheckForUpdatesService(dispatch,appState);
  const {getDeviceStatus} = useDeviceStatusService()
  const DeviceValidation = appState?.appState?.configuration?.DeviceValidation;
/*   const performCPUCheck=()=>{
    console.log(logPrefix, "performCPUCheck");
    return new Promise<boolean>((resolve) => {
      resolve(true);
    })
  }
  const performMemoryCheck=()=>{
    console.log(logPrefix, "performMemoryCheck");
    return new Promise<boolean>((resolve) => {
      resolve(true);
    })
  }
 const performConnectionCheck=()=>{
  console.log(logPrefix, "performConnectionCheck");
  return new Promise<boolean>((resolve) => {
    resolve(true);
  })
 } */
 const performVersionCheck=()=>{
  console.log(logPrefix, "performVersionCheck");
  return new Promise<ValidationResponse & checkStatus>((resolve) => {
    const versionCheck: ValidationResponse & checkStatus  = {
      name: DeviceValidation?.checkVersion.name || "checkVersion",
      threshold: "",
      time: TimeService.current(),
      type:DeviceValidation?.checkVersion.type || ValidationResponseCheck.HARD_CHECK,
      message:"",
      value:appState.appState.releaseVersion || "NotFound",
      isCheckPassed: false,
      actionOnFailure: "FailedVersionCheck",
   }
    const onResponse=(response:any)=>{
      const manifest: Manifest = response;
      if(!response || response?.status!==200){
        versionCheck.message =  "Failed"
        versionCheck.isCheckPassed = false;
        versionCheck.value = response?.status;
        versionCheck.actionOnFailure= "NoServerConnectionDetected";
        versionCheck.threshold = "Server release version is not available";
        resolve(versionCheck);
        return;
      }
      else if(manifest.infoCode=== "INFO-6001" && manifest.manifest?.product?.version !== appState.appState.releaseVersion){
        versionCheck.message = "Mismatch";
        versionCheck.threshold = manifest.manifest?.product?.version
        versionCheck.value = appState.appState.releaseVersion || "NotFound";
        versionCheck.isCheckPassed = false
      }
      else if(manifest.infoCode=== "INFO-6001" && manifest.manifest?.product?.version === appState.appState.releaseVersion){
        versionCheck.message =  "Match";
        versionCheck.threshold = manifest.manifest?.product?.version
        versionCheck.value = appState.appState.releaseVersion;
        versionCheck.isCheckPassed = true
      }
      else {
        versionCheck.message =  "Match";
        versionCheck.threshold = appState.appState.releaseVersion || "NotFound";
        versionCheck.value = appState.appState.releaseVersion || "NotFound";
        versionCheck.isCheckPassed = true;
      }
      resolve(versionCheck);
    }
      FetchReleaseManifest(onResponse).catch((e:any)=>{
        versionCheck.message =  "Warning"
        versionCheck.value = JSON.stringify(e); 
        versionCheck.isCheckPassed = true;
        resolve(versionCheck);
      });
  })
  
 }

 const performNCSVersionCheck=()=>{
  console.log(logPrefix, "performNCSVersionCheck");
  return new Promise<ValidationResponse & checkStatus>((resolve) => {
    const versionCheck: ValidationResponse & checkStatus = {
      name: DeviceValidation?.checkVersion.name || "performNCSVersionCheck",
      threshold: "",
      time: TimeService.current(),
      type:DeviceValidation?.checkVersion.type || ValidationResponseCheck.HARD_CHECK,
      message:"",
      value:"",
      isCheckPassed: false,
      actionOnFailure: "FailedVersionCheck",
   }
    if(appState.connectedNCSState){
      if(appState.connectedNCSState.eNAEPVersionStudentApp === appState.appState.releaseVersion){
        versionCheck.message =  "Match"
        versionCheck.threshold = appState.connectedNCSState.eNAEPVersionStudentApp ;
        versionCheck.value = appState.appState.releaseVersion;
        versionCheck.isCheckPassed = true;
      }
      else {
        versionCheck.message =  "Mismatch"
        versionCheck.threshold = appState.connectedNCSState.eNAEPVersionStudentApp ;
        versionCheck.value = appState.appState.releaseVersion || "NotFound";
        versionCheck.isCheckPassed = false;
      }
    }
    else {
      versionCheck.message =  "Warning"
      versionCheck.value = appState.appState.releaseVersion || "NotFound"
      versionCheck.threshold = "Server release version is not available"
      versionCheck.isCheckPassed = false;
      versionCheck.actionOnFailure= "NoNCSConnectionDetected";
    }
    resolve(versionCheck);
  })
 }
 const performHealthCheck=()=>{
  console.log(logPrefix, "performHealthCheck");
  const config  = appState.appState.configuration;
  return new Promise<ValidationResponse & checkStatus>((resolve) => {
    const helathCheck = appState.sessionState.selectedAssessmentMode === "ncs" ? DeviceValidation?.checkNCSServerHealth : DeviceValidation?.checkCloudServerHealth
  const healthCheck: ValidationResponse & checkStatus = {
    name: helathCheck?.name || "performHealthCheck",
    threshold: helathCheck?.threshold,
    time: TimeService.current(),
    type:helathCheck?.type || ValidationResponseCheck.HARD_CHECK,
    message:"",
    value:"",
    isCheckPassed: false,
    actionOnFailure: "NoServerConnectionDetected",
 }
  let url = `${environment.resolveApiDomain()}/${config?.onlineServices?.cloudServiceHealth}`;
  if(appState.sessionState.selectedAssessmentMode === "ncs" && appState.connectedNCSState){
    url = `https://${appState.connectedNCSState?.connectionInfo.ipAddress}:${appState.connectedNCSState?.config.adsServices.port}/session-service/health`;
  }
  console.info("The reponse of the health check",url);
  axios.get(url).then((response)=>{
    healthCheck.message = response?.data
    healthCheck.value = response?.status.toLocaleString();
    console.info("The reponse of the health check",response?.data);
    response?.status === 200 ? healthCheck.isCheckPassed = true: healthCheck.isCheckPassed = false;
  }).catch((e)=>{
    healthCheck.message = "Failed"
    healthCheck.value = JSON.stringify(e);
    healthCheck.isCheckPassed = false;
  }).finally(()=>{
    resolve(healthCheck)
  })
})
 }
 const performEnvCheck=(environment:string)=>{
  console.log(logPrefix, "performEnvCheck");
  return new Promise<ValidationResponse & checkStatus>((resolve) => { 
  const envCheck: ValidationResponse & checkStatus = {
    name: DeviceValidation?.checkEnv?.name || "checkEnv",
    threshold: environment || DeviceValidation?.checkEnv?.threshold,
    time: TimeService.current(),
    type:DeviceValidation?.checkEnv?.type || ValidationResponseCheck.HARD_CHECK,
    message:"",
    value:"",
    isCheckPassed: false,
    actionOnFailure: "SystemError",
 }
    if(appState.sessionState.selectedAssessmentMode!== "ncs"){
      envCheck.message = "Skipped";
      envCheck.value = `online mode selected skipping check.`;
      envCheck.isCheckPassed = true;
    }
    else if(environment !== appState.appState.configuration?.environment) {
      console.log("The environment is set to:",environment)
      envCheck.message = "Failed";
      envCheck.value = `NCS Environment ${environment} does not match student app ${appState.appState.configuration?.environment}`;
      envCheck.isCheckPassed = false;
    }else{
     envCheck.isCheckPassed = true
     envCheck.message = "Success";
     envCheck.value= appState.appState.configuration?.environment || "NotAvailable"
    }
    resolve(envCheck)
  })
 }
 const performSystemClockCheck=()=>{
  console.log(logPrefix, "performSystemClockCheck");
  const provider = AppStateProvider.getInstance();
  const appState:IADPState = provider.getState();
  const config  = appState.appState.configuration;
  return new Promise<ValidationResponse & checkStatus >((resolve) => {
    let serverTimeUTC: Date | null = null;
    let localTimeUTC: Date | null = null;
    const systemClockCheck: ValidationResponse & checkStatus = {
    name: DeviceValidation?.checkSystemClock.name || "performSystemClockCheck",
    threshold: DeviceValidation?.checkSystemClock.threshold.toString(),
    time: TimeService.current(),
    type:appState.sessionState.selectedAssessmentMode === "ncs" ? ValidationResponseCheck.SOFT_CHECK : DeviceValidation?.checkSystemClock.type || ValidationResponseCheck.HARD_CHECK,
    message:"",
    value:"",
    isCheckPassed: false,
    actionOnFailure: "FailedSystemTimeCheck"
  };
  let url = `${environment.resolveApiDomain()}/${config?.onlineServices?.cloudServiceHealth}`;
  if(appState.sessionState.selectedAssessmentMode === "ncs" && appState.connectedNCSState){
    url = `https://${appState.connectedNCSState?.connectionInfo.ipAddress}:${appState.connectedNCSState?.config.adsServices.port}/session-service/health`;
  }
  axios.get(url).then((response)=>{
    console.log(response.data);
    const dateFromResponse = response.data?.date ? response.data?.date : response.data?.data?.date
    if(dateFromResponse){
       serverTimeUTC = new Date(dateFromResponse);
       localTimeUTC = TimeService.getNowUTC();
       console.log(logPrefix,'server time', serverTimeUTC.getTime(), "local time", localTimeUTC.getTime());
       let offset = serverTimeUTC.getTime() - localTimeUTC.getTime();
       const isValid = TimeService.isValidLocalTime(offset, DeviceValidation?.checkSystemClock.threshold);
       systemClockCheck.message = isValid ? "Success" : "Failed";
       systemClockCheck.threshold = serverTimeUTC.toISOString();
       systemClockCheck.value = localTimeUTC.toISOString();
       systemClockCheck.isCheckPassed = isValid;
         }
    else {
      console.warn(`checkSystemClock unable to date from cloud services: (${url})`);
      serverTimeUTC = TimeService.getNowUTC();
      systemClockCheck.message = "Warning";
      systemClockCheck.value = `checkSystemClock unable to date from cloud services: (${url}. Date property is missing)`
      systemClockCheck.isCheckPassed = false;
    }
  }).catch((e)=>{
    console.warn(`checkSystemClock unable to date from cloud services: (${e})`);
    serverTimeUTC = TimeService.getNowUTC();
    systemClockCheck.message = "Warning";
    systemClockCheck.value = `checkSystemClock unable to date from cloud services: (${e})`
    systemClockCheck.isCheckPassed = true;
  }).finally(()=>{
    resolve(systemClockCheck);
  })
 
  });
 
 }
 const  performStressTest=async (config?:AppConfigExtended)=>{
  console.log(logPrefix, "performStressTest");
  const provider = AppStateProvider.getInstance();
  const state = provider.getState();
  const deviceValidationStatus: DeviceReadinessInfo={
    "readinessCheckStartedAt": state.deviceReadinessState.deviceReadinessInfo?.readinessCheckStartedAt as string,
    "deviceReadinessCheckPassed": true,          
    "state": "StressTestInProgress",
    "failureReason": [],
    "readinessCheckCompletedAt": new Date().toISOString()    
  }
  dispatch(actions.createUpdateDeviceValidationStateAction(deviceValidationStatus));
  return new Promise<ValidationResponse & checkStatus>(async (resolve) => {
    const stressTestCheck: ValidationResponse & checkStatus = {
      name: DeviceValidation?.checkBattery.name || "checkBattery",
      threshold: DeviceValidation?.checkBattery.threshold.toLocaleString(),
      time: TimeService.current(),
      type:DeviceValidation?.checkBattery.type || ValidationResponseCheck.HARD_CHECK,
      message:"",
      value: "",
      isCheckPassed: true,
      actionOnFailure: "FailedModeOneCheck"
    }
    if(!config) {
      resolve(stressTestCheck);
      return;
    };
    const results:StressSummary = await RunStressTest(config,state);
    stressTestCheck.value = JSON.stringify(results);
    stressTestCheck.isCheckPassed = results.successCount > config.stressTestConfig.minSuccessRateinSets;
    const stressTest: StressTest = {
      state: "Completed",
      stressTestPassed:stressTestCheck.isCheckPassed,
    }
     //check if device is still online
     const isOnline =  navigator.onLine //await isDeviceOnlineWithAccessToNAEPCloud();
     if(!isOnline){
      stressTest.stressTestSummary = results;
      dispatch(actions.createSetStressTestAction(stressTest));
      dispatch(actions.createSetViewAction("StressTestDisconnectedView"));
      stressTest.state = "Incomplete";
     }
     else {
      await postStressTestDeviceMetrics(stressTest);
      //get device status 
      const paylod = {
        setupCode: state.sessionState.schoolDetails?.setupCode,
        assessmentLocation:state.sessionState.selectedAssessmentLocation,
        devices:[]
      };
      //strt timer get device status to set the overall NST state
      let deviceStatusTimeout: any  | undefined =  setTimeout(()=>{
        stressTest.state = "Incomplete";
        stressTest.stressTestPassed = false;
        stressTest.stressTestSummary = results;
        dispatch(actions.createSetStressTestAction(stressTest));
        stressTestCheck.isClassroomStressTestPassed = false;
        resolve(stressTestCheck);
        deviceStatusTimeout=undefined;
        },120*1000);//TODO - change to actual value

      const onDeviceStatus = (response:any)=>{
        console.log("device status", response.classroomNetworkStressTest)
        if(response &&  response?.classroomNetworkStressTest === "Failed"){
          clearTimeout(deviceStatusTimeout);
          deviceStatusTimeout=undefined;
          stressTest.state = "Failed";
          stressTest.stressTestPassed = false;
          stressTest.stressTestSummary = results;
          dispatch(actions.createSetStressTestAction(stressTest));
          stressTestCheck.isClassroomStressTestPassed = false;
          resolve(stressTestCheck);
        }
        else if (response &&  response.classroomNetworkStressTest === "Passed") {
          clearTimeout(deviceStatusTimeout);
          deviceStatusTimeout=undefined;
          stressTest.state = "Completed";
          stressTest.stressTestPassed = true;
          stressTest.stressTestSummary = results;
          stressTestCheck.isClassroomStressTestPassed = true;
          dispatch(actions.createSetStressTestAction(stressTest));
          resolve(stressTestCheck);
        }
        else {
          //if timer is still running, check for status every 5 seconds
          if(deviceStatusTimeout){
            setTimeout(()=>{
              getDeviceStatus(JSON.stringify(paylod),onDeviceStatus);
            },5000); 
          }
        }
      }
      getDeviceStatus(JSON.stringify(paylod),onDeviceStatus)
     }
  })
 };
 const performBatteryCheck= async ()=>{
  //@ts-ignore
  const batteryLevel = await navigator.getBattery();
  return new Promise<ValidationResponse & checkStatus >((resolve) => {
   const batteryCheck: ValidationResponse & checkStatus = {
    name: DeviceValidation?.checkBattery.name || "checkBattery",
    threshold: DeviceValidation?.checkBattery.threshold.toLocaleString(),
    time: TimeService.current(),
    type:DeviceValidation?.checkBattery.type || ValidationResponseCheck.HARD_CHECK,
    message:(batteryLevel?.level || 0) * 100 < DeviceValidation?.checkBattery.threshold ? "Warning" : "Success",
    value:JSON.stringify({batteryLevel: batteryLevel?.level, isCharging: batteryLevel?.charging,dischargingTime: batteryLevel?.dischargingTime}),
    isCheckPassed: true,
    actionOnFailure: "SystemError"
  }
  resolve(batteryCheck);
})
}
const _postDeviceMetrics= async (pendingStressTest?: boolean,failureReasons?: any[])=>{
  const {postDeviceMetrics} = DeviceMetricsService();
  const provider = AppStateProvider.getInstance();
  const state = provider.getState();
  const deviceValidationStatus: DeviceReadinessInfo={
    "readinessCheckStartedAt": state.deviceReadinessState.deviceReadinessInfo?.readinessCheckStartedAt as string,
    "deviceReadinessCheckPassed": pendingStressTest ? true : (!failureReasons || failureReasons.length === 0) ? true  : false ,          
    "state": (failureReasons  && failureReasons.length > 0) ? "ReadinessCheckCompleted" : pendingStressTest ? "WaitingForStressTest" : "ReadinessCheckCompleted",
    "failureReason": failureReasons || [],
    "readinessCheckCompletedAt": new Date().toISOString()     
  };
  //udpate state first prior posting the device metrics API to avoid race condition
  dispatch(actions.createUpdateDeviceValidationStateAction(deviceValidationStatus));
  await postDeviceMetrics(state,deviceValidationStatus,undefined);
  return;
}
const _postDeviceMetricsInProgress= async ()=>{
  const {postDeviceMetrics} = DeviceMetricsService();
  const provider = AppStateProvider.getInstance();
  const state = provider.getState();
  const deviceValidationStatus: DeviceReadinessInfo={
    "readinessCheckStartedAt": new Date().toISOString(),
    "deviceReadinessCheckPassed": false ,          
    "state": "ReadinessCheckInProgress",
    "failureReason":  [],
    "readinessCheckCompletedAt": ""     
  };
  await postDeviceMetrics(state,deviceValidationStatus);
  dispatch(actions.createUpdateDeviceValidationStateAction(deviceValidationStatus));
  return;
}
const postStressTestDeviceMetrics = async(stressTest:StressTest)=>{
  const {postDeviceMetrics} = DeviceMetricsService();
  const provider = AppStateProvider.getInstance();
  const state = provider.getState();
  const deviceValidation: DeviceReadinessInfo={
    "readinessCheckStartedAt": state.deviceReadinessState.deviceReadinessInfo?.readinessCheckStartedAt as string,
    "deviceReadinessCheckPassed": stressTest.state === "Completed" || stressTest.state === "Skipped",          
    "state": stressTest.state === "InProgress" ? "StressTestInProgress" : "ReadinessCheckCompleted",
    "failureReason":  [],
    "readinessCheckCompletedAt": new Date().toISOString()     
  };
  await postDeviceMetrics(state,deviceValidation,stressTest);
  dispatch(actions.createUpdateDeviceValidationStateAction(deviceValidation));
  return;
}
 const postAllValidationLogsFromIndexDB= async (config?:AppConfigExtended)=>{
  const dbInstance = await indexDBStorage.getInstance();
  const keys = await dbInstance.transactions.getAll("adp-device-validation-indexed");
  console.log("postAllValidationLogsFromIndexDB",keys);
  
  await Promise.all(keys.map(async (key:IDBValidKey) => {
    const data = await dbInstance.transactions.get("adp-device-validation-indexed",key as string);
    if(!appState.appState.appLaunchId?.includes(key as string)){
      const fileName = `${key}.device-validation.json`
      const {payload,logHeader} = RequestService.constructDeviceValidationDataTransferPayload(appState,fileName);
      let status = undefined as any
      if(data?.deviceReadinessChecks){
        status= await RequestService.postValidationLogs(appState,fileName,{logHeader:data?.logHeader ||logHeader,payload:payload},data.deviceReadinessChecks,config);
      }
      else{
        status= await RequestService.postValidationLogs(appState,fileName,{logHeader:logHeader,payload:payload},data,config);
      }
        if(status){
          console.log(`successfully sent ${fileName} from the indexdb store. Deleting record form the indexdb.`)
          dbInstance.transactions.delete("adp-device-validation-indexed",key as string);
        }
    }
    }));
  return;
} 
const getSummary = (results:ValidationResponse[]) =>{
  const provider = AppStateProvider.getInstance();
  const state:IADPState = provider.getState();
  const {logHeader} = RequestService.constructDeviceValidationDataTransferPayload(appState,"");
  const failures = results.find(result => result.isCheckPassed === false && result.type === ValidationResponseCheck.HARD_CHECK);
  const deviceReadinessChecks:ValidationSummary = {
    ...logHeader,
    deviceName:state?.deviceState?.deviceId || "NotAvailable",
    status:failures ? "Failure" : "Success",
    responses:results
  }
  return deviceReadinessChecks;
}
 const postDeviceValidationLog = async(results:ValidationResponse[])=>{
  const provider = AppStateProvider.getInstance();
  const state:IADPState = provider.getState();
  if(!state.appState.appLaunchId)return;
  const fileName = `${state.appState.appLaunchId}.${state.sessionState.selectedAssessmentMode}.device-validation.json`; 
  const {logHeader,payload} = RequestService.constructDeviceValidationDataTransferPayload(state,fileName);
  if(window.navigator.onLine){
    const response = await RequestService.postValidationLogs(state,fileName,{logHeader,payload});
    if(!response){
      //if posting failed store in indexDB for later re-posting
      if(state.appState.appLaunchId)indexDBStorage.storeValidationLogs({ logHeader:logHeader,deviceValidationChecks:getSummary(results)},state.appState.appLaunchId);
    };
    //post stored logs af any
    await postAllValidationLogsFromIndexDB();
  }
  else {
    if(state.appState.appLaunchId)indexDBStorage.storeValidationLogs({ logHeader:logHeader,deviceValidationChecks:getSummary(results)},state.appState.appLaunchId);
  }
 };
 const postLocationDeviceMetrics = async()=>{
  const {postDeviceMetrics} = DeviceMetricsService();
  const provider = AppStateProvider.getInstance();
  const state = provider.getState();
    const deviceValidation: DeviceReadinessInfo={
      "readinessCheckStartedAt": state.deviceReadinessState.deviceReadinessInfo?.readinessCheckStartedAt as string,
      "deviceReadinessCheckPassed": state.deviceReadinessState.deviceReadinessInfo?.state.includes("ReadinessCheckCompleted") || false,          
      "state": state.deviceReadinessState.deviceReadinessInfo?.state || "ReadinessCheckInProgress",
      "failureReason": state.deviceReadinessState?.deviceReadinessInfo?.failureReason || [],
      "readinessCheckCompletedAt": new Date().toISOString()   
    };
    await postDeviceMetrics(state,deviceValidation,undefined,state?.sessionState?.selectedAssessmentLocation);
    dispatch(actions.createSetViewAction("DeviceValidationView"));

  return;
}
 const  performOnlineDeviceValidation= async ()=>{
  await _postDeviceMetricsInProgress();
  return new Promise<boolean>(async (resolve) => {
    Promise.all([performHealthCheck(),performSystemClockCheck(),performVersionCheck()]).then(async (results)=>{
      //console.log(results);
      dispatch(actions.createSetDeviceReadinessSummary(results));
      await sleep(50);
      const failedChecks = results.filter(result => !result.isCheckPassed && result.type === ValidationResponseCheck.HARD_CHECK);
      await postDeviceValidationLog(results);
     if(failedChecks.length > 0){
      await _postDeviceMetrics(false,failedChecks);
      dispatch(actions.createErrorAction(failedChecks[0].actionOnFailure));
      resolve(false);
     }
     else {
      await _postDeviceMetrics(true);
      resolve(true);
     }
    });
    })
  }
  const  performEnvDeviceValidation= async (environment:string)=>{
    await _postDeviceMetricsInProgress();
    return new Promise<boolean>(async (resolve) => {
      Promise.all([performEnvCheck(environment)]).then(async (results)=>{
        //console.log(results);
        dispatch(actions.createSetDeviceReadinessSummary(results));
        await sleep(50);
        const failedChecks = results.filter(result => !result.isCheckPassed && result.type === ValidationResponseCheck.HARD_CHECK);
        await postDeviceValidationLog(results);
       if(failedChecks.length > 0){
        await _postDeviceMetrics(false,failedChecks);
        dispatch(actions.createErrorAction(failedChecks[0].actionOnFailure));
        resolve(false);
       }
       else {
        await _postDeviceMetrics(true);
        resolve(true);
       }
      });
      })
    }
 const  performNCSModeDeviceValidation= async ()=>{
  await _postDeviceMetricsInProgress();
  return new Promise<boolean>(async (resolve) => {
    Promise.all([performHealthCheck(),performNCSVersionCheck(),performSystemClockCheck()]).then(async (results)=>{
      //console.log(results);
      dispatch(actions.createSetDeviceReadinessSummary(results));
      await sleep(50);
      await postDeviceValidationLog(results);
      const failedChecks = results.filter(result => !result.isCheckPassed && result.type === ValidationResponseCheck.HARD_CHECK);
      if(failedChecks.length > 0){
        await _postDeviceMetrics(false, failedChecks);
       dispatch(actions.createErrorAction(failedChecks[0].actionOnFailure));
       resolve(false);
      }
      else {
        await _postDeviceMetrics(false);
        resolve(true);
       }
    });
  }); 
 }
 const  performSystemChecks= async ()=>{
    return new Promise<boolean>(async (resolve) => {
    Promise.all([performBatteryCheck()]).then(async (results)=>{
      //console.log(results);
      dispatch(actions.createSetDeviceReadinessSummary(results));
      const failedChecks = results.filter(result => !result.isCheckPassed && result.type === ValidationResponseCheck.HARD_CHECK);
      if(failedChecks.length > 0){
      dispatch(actions.createErrorAction(failedChecks[0].actionOnFailure));
      resolve(false);
     }
     else {
      resolve(true);
     }
    });
    })
  }

  return {performSystemChecks,performSystemClockCheck,postDeviceValidationLog,performNCSModeDeviceValidation,performOnlineDeviceValidation,performStressTest,postStressTestDeviceMetrics,postLocationDeviceMetrics,postAllValidationLogsFromIndexDB,performEnvCheck,performEnvDeviceValidation};
}
